import { errorHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { useCallback } from 'react';

import { handleQBooksIntegration } from '../helpers/handleQBooksIntegration';
import { handleSsoIntegration } from '../helpers/handleSsoIntegration';
import { handleXeroIntegration } from '../helpers/handleXeroIntegration';
import { OAuthContext } from '../types';

export const useLoadData = (ctx: OAuthContext) => {
    const { uiState } = ctx;

    return useCallback(async () => {
        switch (uiState.type) {
            case 'oauth': {
                switch (uiState.integrationType) {
                    case domain.IntegrationType.Xero:
                        return await handleXeroIntegration(ctx);
                    case domain.IntegrationType.QBooks:
                        return await handleQBooksIntegration(ctx);
                    case domain.IntegrationType.NetSuite:
                    case domain.IntegrationType.Dear:
                    case domain.IntegrationType.None:
                        throw errorHelpers.invalidOperationError();

                    default:
                        throw errorHelpers.assertNever(uiState.integrationType);
                }
            }

            case 'sso':
                return await handleSsoIntegration(ctx);
            default:
                throw errorHelpers.assertNever(uiState);
        }
    }, [ctx, uiState]);
};
